import { api } from './client';

export interface TrustedIp {
  ip: string;
  description: string | null;
  createdAt?: number;
}

export const trustedIpsApi = {
  list: () =>
    api.get<{
      items: TrustedIp[];
      myIp: string | null;
      myIpIsTrusted: boolean;
    }>('/api/admin/trusted-ips'),
  add: (ip: string, description?: string) =>
    api.post<TrustedIp>('/api/admin/trusted-ips', { ip, description }),
  remove: (ip: string) =>
    api.del<{ ok: true }>(`/api/admin/trusted-ips/${encodeURIComponent(ip)}`),
};
